import { render, staticRenderFns } from "./RelatorioIAModal.vue?vue&type=template&id=7163dd1c&scoped=true"
import script from "./RelatorioIAModal.vue?vue&type=script&lang=js"
export * from "./RelatorioIAModal.vue?vue&type=script&lang=js"
import style0 from "./RelatorioIAModal.vue?vue&type=style&index=0&id=7163dd1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7163dd1c",
  null
  
)

export default component.exports